// document.addEventListener('DOMContentLoaded', () => {

//   function closeAmpCart() {
//     document
//       .querySelector('.amp-cart')
//       ?.classList.remove('amp-cart--open');
//   }

//   document.addEventListener('click', e => {

//     if (e.target.closest('.amp-cart__header-close-button')) {
//       closeAmpCart();
//       return;
//     }

//     if (e.target.classList.contains('amp-cart-drawer__overlay')) {
//       closeAmpCart();
//       return;
//     }

//   });

//   document.addEventListener('keydown', e => {
//     if (e.key === 'Escape') {
//       closeAmpCart();
//     }
//   });

// });


// document.addEventListener('DOMContentLoaded', () => {

//   function getMainColor() {
//     const checked = document.querySelector('[name="Color"]:checked');
//     return checked ? checked.value.toLowerCase().trim() : null;
//   }

//   function updateRecommendationImages() {
//     const selectedColor = getMainColor();
//     if (!selectedColor) return;

//     document.querySelectorAll('.omr-card-color-gallery').forEach(gallery => {
//       const images = Array.from(gallery.querySelectorAll('.omr-color-image'));
//       const hasMatch = images.some(img => img.dataset.color.toLowerCase() === selectedColor);

//       if (hasMatch) {
//         images.forEach(img => {
//           img.style.display = img.dataset.color.toLowerCase() === selectedColor ? 'block' : 'none';
//         });
//       }
//     });
//   }

//   updateRecommendationImages();

//   document.addEventListener('change', e => {
//     if (e.target.matches('[name="Color"]')) {
//       updateRecommendationImages();
//     }
//   });

// });

// document.addEventListener('DOMContentLoaded', () => {

//   function getMainColor() {
//     const checked = document.querySelector(
//       '[name="Color"]:checked, .main-color-swatch.is-active'
//     );
//     return checked ? checked.value : null;
//   }

//   function getAllSizes(variants) {
//     return [...new Set(
//       variants.filter(v => v.available).map(v => v.size)
//     )];
//   }

//   function updateSizes(form) {
//     const sizeSelect = form.querySelector('.omr-size-select');
//     const variantInput = form.querySelector('.omr-variant-id');
//     const atcBtn = form.querySelector('.omr-atc-btn');
//     const variants = JSON.parse(variantInput.dataset.variants);
//     const color = getMainColor();

//     if (!sizeSelect) return;

//     sizeSelect.innerHTML =
//       '<option value="" disabled selected>Taille</option>';

//     let sizes;

//     if (!color) {
//       sizes = getAllSizes(variants);
//     } else {
//       sizes = variants
//         .filter(v => v.available && v.color === color)
//         .map(v => v.size);

//       if (!sizes.length) {
//         sizes = getAllSizes(variants);
//       }
//     }

//     [...new Set(sizes)].forEach(size => {
//       const opt = document.createElement('option');
//       opt.value = size;
//       opt.textContent = size;
//       sizeSelect.appendChild(opt);
//     });

//     atcBtn.disabled = true;
//     variantInput.value = '';
//   }

//   function updateVariant(form) {
//     const size = form.querySelector('.omr-size-select')?.value;
//     const color = getMainColor();
//     const variantInput = form.querySelector('.omr-variant-id');
//     const atcBtn = form.querySelector('.omr-atc-btn');
//     const variants = JSON.parse(variantInput.dataset.variants);

//     if (!size) return;

//     let match =
//       variants.find(v =>
//         v.available &&
//         v.size === size &&
//         v.color === color
//       ) ||
//       variants.find(v =>
//         v.available &&
//         v.size === size
//       );

//     if (match) {
//       variantInput.value = match.id;
//       atcBtn.disabled = false;
//     } else {
//       atcBtn.disabled = true;
//     }
//   }

//   document.querySelectorAll('.omr-atc-form').forEach(updateSizes);

//   document.addEventListener('change', e => {

//     if (e.target.matches('[name="Color"], .main-color-swatch')) {
//       document.querySelectorAll('.omr-atc-form').forEach(updateSizes);
//     }

//     if (e.target.matches('.omr-size-select')) {
//       updateVariant(e.target.closest('.omr-atc-form'));
//     }
//   });

//   document.addEventListener('submit', async e => {
//     const form = e.target.closest('.omr-atc-form');
//     if (!form) return;

//     e.preventDefault();

//     const variantId = form.querySelector('.omr-variant-id').value;
//     const atcBtn = form.querySelector('.omr-atc-btn');

//     if (!variantId) {
//       console.warn('No variant ID selected');
//       return;
//     }

//     atcBtn.disabled = true;
//     atcBtn.textContent = 'Ajout en cours…';

//     try {
//       const res = await fetch('/cart/add.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ id: variantId, quantity: 1 })
//       });

//       if (!res.ok) throw new Error('Add failed');

//       await res.json();

//       atcBtn.textContent = 'Ajouté ✓';

//       const ampCart = document.querySelector('.amp-cart');
//       if (ampCart) ampCart.classList.add('amp-cart--open');

//       setTimeout(() => {
//         atcBtn.textContent = 'Ajout rapide';
//         atcBtn.disabled = false;
//       }, 1200);

//     } catch (err) {
//       console.error(err);
//       atcBtn.textContent = 'Erreur';
//       atcBtn.disabled = false;
//     }
//   });

// });

document.addEventListener('DOMContentLoaded', () => {

  function closeAmpCart() {
    document
      .querySelector('.amp-cart')
      ?.classList.remove('amp-cart--open');
  }

  document.addEventListener('click', e => {

    if (e.target.closest('.amp-cart__header-close-button')) {
      closeAmpCart();
      return;
    }

    if (e.target.classList.contains('amp-cart-drawer__overlay')) {
      closeAmpCart();
      return;
    }

  });

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') {
      closeAmpCart();
    }
  });

  function getMainColor() {
    const checked = document.querySelector(
      '[name="Couleur"]:checked, [name="Color"]:checked, [name="Couleurs"]:checked, [name="Coques de Couleur"]:checked, .main-color-swatch.is-active'
    );
    return checked ? checked.value?.toLowerCase().trim() : null;
  }

  function updateRecommendationImages() {
    const selectedColor = getMainColor();
    if (!selectedColor) return;

    document.querySelectorAll('.omr-card-color-gallery').forEach(gallery => {
      const images = Array.from(gallery.querySelectorAll('.omr-color-image'));

      const hasMatch = images.some(img =>
        img.dataset.color?.toLowerCase() === selectedColor
      );

      if (hasMatch) {
        images.forEach(img => {
          img.style.display =
            img.dataset.color?.toLowerCase() === selectedColor
              ? 'block'
              : 'none';
        });
      }
    });
  }

  updateRecommendationImages();

  document.addEventListener('change', e => {
    if (e.target.matches('[name="Couleur"], [name="Color"], [name="Couleurs"], [name="Coques de Couleur"]')) {
      updateRecommendationImages();
      document.querySelectorAll('.omr-atc-form').forEach(updateSizes);
    }
  });

  function getAllSizes(variants) {
    return [...new Set(
      variants
        .filter(v => v.available)
        .map(v => v.size)
    )];
  }

  function updateSizes(form) {
    const sizeSelect = form.querySelector('.omr-size-select');
    const variantInput = form.querySelector('.omr-variant-id');
    if (!sizeSelect || !variantInput) return;

    const variants = JSON.parse(variantInput.dataset.variants);
    const color = getMainColor();

    sizeSelect.innerHTML =
      '<option value="" disabled selected>Taille</option>';

    let sizes;

    if (!color) {
      sizes = getAllSizes(variants);
    } else {
      sizes = variants
        .filter(v => v.available && v.color?.toLowerCase() === color)
        .map(v => v.size);

      if (!sizes.length) {
        sizes = getAllSizes(variants);
      }
    }

    [...new Set(sizes)].forEach(size => {
      const opt = document.createElement('option');
      opt.value = size;
      opt.textContent = size;
      sizeSelect.appendChild(opt);
    });

    variantInput.value = '';
  }

  function updateVariant(form) {
    const size = form.querySelector('.omr-size-select')?.value;
    const color = getMainColor();
    const variantInput = form.querySelector('.omr-variant-id');

    if (!size || !variantInput) return;

    const variants = JSON.parse(variantInput.dataset.variants);

    let match =
      variants.find(v =>
        v.available &&
        v.size === size &&
        v.color?.toLowerCase() === color
      ) ||
      variants.find(v =>
        v.available &&
        v.size === size
      );

    if (match) {
      variantInput.value = match.id;
    }
  }

  document.querySelectorAll('.omr-atc-form').forEach(updateSizes);

  document.addEventListener('change', e => {

    if (e.target.matches('.omr-size-select')) {
      updateVariant(e.target.closest('.omr-atc-form'));
    }

    if (e.target.matches('.main-color-swatch')) {
      document.querySelectorAll('.omr-atc-form').forEach(updateSizes);
    }

  });

  document.addEventListener('submit', async e => {

    const form = e.target.closest('.omr-atc-form');
    if (!form) return;

    e.preventDefault();

    const variantInput = form.querySelector('.omr-variant-id');
    const variantId = variantInput?.value;
    const atcBtn = form.querySelector('.omr-atc-btn');
    const sizeSelect = form.querySelector('.omr-size-select');
    const validationText = form.querySelector('.valid-select');

    atcBtn.classList.remove('error');
    validationText?.classList.remove('show');

    if (!sizeSelect || !sizeSelect.value || !variantId) {

      atcBtn.classList.add('error');
      validationText?.classList.add('show');

      setTimeout(() => {
        atcBtn.classList.remove('error');
        validationText?.classList.remove('show');
      }, 3000);

      return;
    }

    atcBtn.textContent = 'Ajout en cours…';

    try {

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      });

      if (!res.ok) throw new Error('Add failed');

      await res.json();

      atcBtn.textContent = 'Ajouté ✓';

      const ampCart = document.querySelector('.amp-cart');
      if (ampCart) {
        ampCart.classList.add('amp-cart--open');
      }

      setTimeout(() => {
        atcBtn.textContent = 'Ajout rapide';
      }, 1200);

    } catch (err) {

      console.error(err);
      atcBtn.textContent = 'Erreur';

      setTimeout(() => {
        atcBtn.textContent = 'Ajout rapide';
      }, 1200);

    }

  });

});

